import { Home, Settings, Users, X, CreditCard } from 'lucide-react';
import toast from 'react-hot-toast';
import LogoIcon from "../assets/logo.svg";

const InstagramIcon = ({ size = 20 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
);

const Sidebar = ({ activeTab, setActiveTab, sidebarOpen, setSidebarOpen, handleLogout, isMobile, userPlan = 'free', userRole = 'user' }) => {

    const isAdmin = ['admin', 'moderator', 'support'].includes(userRole);
    const isDivulgador = userPlan && userPlan.endsWith('_divulgador');

    const menu = [
        { id: 'home', label: 'Home', icon: <Home size={20} /> },
        { id: 'grupos', label: 'Grupos / Canais', icon: <Users size={20} /> },
        ...(!isDivulgador ? [
            { id: 'instagram_links', label: 'Instagram / Links', icon: <InstagramIcon size={20} /> }
        ] : []),
        { id: 'config', label: 'Configurações', icon: <Settings size={20} /> },
        { id: 'billing', label: 'Pagamentos', icon: <CreditCard size={20} /> },
    ];

    const isLocked = (id) => {
        if (isAdmin || userPlan === 'premium' || userPlan === 'premium_divulgador') return false;

        if (userPlan === 'basic' || userPlan === 'basic_divulgador') {
            return ['chat', 'instagram_links'].includes(id);
        }

        // free / free_divulgador
        return ['chat', 'instagram_links', 'contatos'].includes(id);
    };

    const handleMenuItemClick = (id) => {
        if (isLocked(id)) {
            toast("🔒 Você está visualizando um recurso bloqueado no seu plano atual.", { icon: '👀' });
        }

        setActiveTab(id);
        if (isMobile) {
            setSidebarOpen(false); // Fecha a sidebar no celular ao clicar em um menu
        }
    };

    return (
        <div style={{
            width: '250px',
            backgroundColor: '#1e293b',
            color: 'white',
            padding: '20px',
            position: 'fixed',
            height: '100vh',
            left: sidebarOpen ? '0' : '-250px',
            transition: '0.3s',
            zIndex: 1000,
            boxSizing: 'border-box'
        }}>
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 0', gap: '8px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', cursor: 'default' }}>
                    <img src={LogoIcon} alt="Logo" style={{ width: '50px', height: '50px', objectFit: 'contain', aspectRatio: '1/1', marginBottom: '4px', pointerEvents: 'none' }} />
                    <span style={{ color: '#FD5B1F', fontSize: '20px', fontWeight: '800', textAlign: 'center' }}>Anúncios App</span>
                </div>
                <button onClick={() => setSidebarOpen(false)} style={{ position: 'absolute', right: '0', top: '10px', background: 'none', border: 'none', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px', borderRadius: '4px', transition: '0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                    <X size={20} />
                </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {menu.filter(item => !isLocked(item.id)).map(item => {
                    return (
                        <button
                            key={item.id}
                            onClick={() => handleMenuItemClick(item.id)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '12px 15px',
                                borderRadius: '10px',
                                border: 'none',
                                cursor: 'pointer',
                                textAlign: 'left',
                                width: '100%',
                                backgroundColor: activeTab === item.id ? '#ee4d2d' : 'transparent',
                                color: activeTab === item.id ? 'white' : '#cbd5e1',
                                fontWeight: '700',
                                fontSize: '14px',
                                transition: '0.2s',
                                position: 'relative'
                            }}
                        >
                            {item.icon}
                            <span style={{ flex: 1 }}>{item.label}</span>
                        </button>
                    );
                })}
            </div>

        </div>
    );
};

export default Sidebar;